import React, { useState, useEffect } from 'react';
import { Grid, Box, Typography, TextField, IconButton } from '@mui/material';
import { Formik, Form } from 'formik';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import FormikControl from '../../../../components/FormikControls/FormikControl';
import { codeSchema, phoneNumberSchema, registerByCodeValidationSchema ,registerByCodeValidationSchema1} from '../../StaticData/index';
import { useCheckEmailExists, useCheckExists, useCheckOTP, usePersonByInvitationCode, useRegisterUserByCode, useSendSms } from '../../Hooks';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LockResetIcon from '@mui/icons-material/Person';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import { ErrorMessage } from 'formik';
import "../RegisterTenant/Error.css";
import { checkOTP } from '../../Api';

const RegisterByCode = (props: any) => {
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [email, setEmail] = useState(false);
  const [sms, setSms] = useState(false);
  const [sendPersonByCheckExists, SetsendPersonByCheckExists] = useState<any>();
  const [userPhoneNumber, setUserPhoneNumber] = useState<string>('');
  const [userInvitationCode, setUserInvitationCode] = useState<string>('');
  const [content, setContent] = useState<string>('getPhoneNumber1');
  const [contentMessage, setContentMessage] = useState<string>('لطفا شماره همراه خود را وارد نمایید');
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [showResultToastMessage, setResultShowToastMessage] = useState<boolean>(false);

  const { setContentState } = props;

  const initialCancel = () => {
    setContentState({ content: 'login' });
    setShowToastMessage(true);
    setResultShowToastMessage(true);
  };

  const { mutate: callAddNewPassWord, data: AddNewPassWordData, isLoading: addPassLoad } = useRegisterUserByCode(() => {
    setContentMessage('عملیات با موفقیت انجام شد');
    setResultShowToastMessage(true);
    setShowToastMessage(true);
    setTimeout(() => setContentState({ content: 'login' }), 2000); // هدایت به صفحه ورود بعد از 2 ثانیه
  });

  const { mutate: sendSms, isLoading: sendSmsLoading, data: sendPersonByInvitationCode, isSuccess: isSuccess } = usePersonByInvitationCode(() => {
    setContent('register');
  });

  const { mutate: sendSmsCheckOTP, isLoading: sendSmsLoadingCheckOTP, data: sendPersonByInvitationCodeCheckOTP, isSuccess: isSuccessCheckOTP } = useCheckOTP(() => {
    setContent('getPhoneNumber');
  });

  const { mutate: sendCheckExists, data: sendPersonByCheckExistss } = useCheckExists();
  const { mutate: sendCheckEmailExists, data: sendPersonByCheckEmailExists } = useCheckEmailExists();
 
  const { mutate: sendSmsSendSms, isLoading: sendSmsLoadingSendSms, 
    data: sendPersonByInvitationCodeSendSms, isSuccess: isSuccessSendSms } = useSendSms(() => {
    setContent('check');
  });

  useEffect(() => {
    if (sendPersonByInvitationCodeSendSms) {
      const { data } = sendPersonByInvitationCodeSendSms;
      if (data?.status === 200) {
        setContent('check');
      } else {
        setContent('getPhoneNumber1');
        setContentMessage(data?.message);
        setResultShowToastMessage(false);
        setShowToastMessage(true);
      }
    }
  }, [sendPersonByInvitationCodeSendSms]);

  useEffect(() => {
    if (sendPersonByCheckExistss) {
      const { data } = sendPersonByCheckExistss;
      setSms(data);
    }
  }, [sendPersonByCheckExistss]);

  useEffect(() => {
    if (sendPersonByCheckEmailExists) {
      const { data } = sendPersonByCheckEmailExists;
      setEmail(data);
    }
  }, [sendPersonByCheckEmailExists]);

  useEffect(() => {
    if (sendPersonByInvitationCode) {
      const { data } = sendPersonByInvitationCode;
      const { isSuccess, metaData } = data;
      if (isSuccess) {
        setContentMessage(metaData.message);
        setContent('register');
      } else {
        setContent('getPhoneNumber');
        setContentMessage(metaData.message);
        setResultShowToastMessage(false);
        setShowToastMessage(true);
      }
    }
  }, [sendPersonByInvitationCode]);


  useEffect(() => {
    if (sendPersonByCheckExistss) {
      SetsendPersonByCheckExists(sendPersonByCheckExistss)
    }
  }, [sendPersonByCheckExistss]);

  useEffect(() => {
    if (sendPersonByInvitationCodeCheckOTP) {
      const { data } = sendPersonByInvitationCodeCheckOTP;
      if (data) {
        setContent('getPhoneNumber');
      } else {
        setContentMessage('کد صحیح نمی باشد');
        setResultShowToastMessage(false);
        setShowToastMessage(true);
      }
    }
  }, [sendPersonByInvitationCodeCheckOTP]);

  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const renderContent = () => {
    switch (content) {
      case 'getPhoneNumber1':
        return (
          <Formik
            enableReinitialize
            validationSchema={phoneNumberSchema}
            initialValues={{ phoneNumber: '',smsType:'Register'}}
            onSubmit={(data: any) => {
              const { phoneNumber} = data;
              setUserPhoneNumber(phoneNumber);
              sendSmsSendSms(data);
            }}
          >
            {({ values, setFieldValue, dirty, isValid }) => (
              <Form>
                <Grid container columnSpacing={1} sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}>
                  <Grid item xs={7} flexGrow={1} mx={'auto'}>
                    <FormikControl
                      control='textField'
                      label='شماره تلفن'
                      name='phoneNumber'
                      fullWidth
                      value={values.phoneNumber || ''}
                    />
                  </Grid>
                  <Grid item xs={6} flexGrow={1} mx={'auto'}>
                    <Box>
                      <DyButton
                        caption={'ارسال کد'}
                        color={'#00387C'}
                        onClick={() => { }}
                        disabled={!isValid || !dirty || sendSmsLoadingSendSms}
                        variant={'contained'}
                        bgColor={'#00387C'}
                        type={'submit'}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        );
      case 'getPhoneNumber':
          return (
            <Formik
              enableReinitialize
              validationSchema={phoneNumberSchema}
              initialValues={{ phoneNumber: userPhoneNumber, invitationCode: '' }}
              onSubmit={(data: any) => {
                const { phoneNumber, invitationCode } = data;
                setUserPhoneNumber(phoneNumber);
                sendCheckExists(data);
                sendCheckEmailExists(data);
                setUserInvitationCode(invitationCode);
                sendSms(data);
              }}
            >
              {({ values, setFieldValue, dirty, isValid }) => (
                <Form>
                  <Grid container columnSpacing={1} sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}>
                    {/* <Grid item xs={7} flexGrow={1} mx={'auto'}>
                      <FormikControl
                        control='textField'
                        label='شماره تلفن'
                        name='phoneNumber'
                        fullWidth
                        value={values.phoneNumber || ''}
                      />
                    </Grid> */}
                    <Grid item xs={7} flexGrow={1} mx={'auto'}>
                      <FormikControl
                        control='textField'
                        label='کد دعوت'
                        name='invitationCode'
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6} flexGrow={1} mx={'auto'}>
                      <Box>
                        <DyButton
                          caption={'بررسی کد دعوت'}
                          color={'#00387C'}
                          onClick={() => { }}
                          disabled={!isValid || !dirty || sendSmsLoading}
                          variant={'contained'}
                          bgColor={'#00387C'}
                          type={'submit'}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          );
      case 'check':
            return (
              <Formik
                enableReinitialize
                validationSchema={codeSchema}
                initialValues={{
                  phoneNumber: userPhoneNumber,
                  code: ''
                }}
                onSubmit={(data: any) => {
                  sendSmsCheckOTP(data);
                }}
              >
                {({ values, setFieldValue, dirty, isValid }) => (
                  <Form>
                    <Grid container columnSpacing={1} sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}>
                      <Grid item xs={7} flexGrow={1} mx={'auto'}>
                        <Box>
                          <div className='error'>
                          </div>
                          <FormikControl
                            control='textField'
                            name='code'
                            fullWidth
                            size='small'
                            value={values.code}
                            onChange={({ target }: any) => {
                              setFieldValue('code', target.value);
                            }}
                            label={'کد ارسال شده'}
                          />
                        </Box>
                      </Grid>
                      <Grid item xs={6} flexGrow={1} mx={'auto'} marginTop={1}>
                        <Box>
                          <DyButton
                            caption={'تایید'}
                            color={'#00387C'}
                            onClick={() => { }}
                            disabled={addPassLoad || !isValid || !dirty}
                            variant={'contained'}
                            bgColor={'#00387C'}
                            type={'submit'}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            );
      case 'register':
        return (
          <Formik
            enableReinitialize
            validationSchema={!sms ? registerByCodeValidationSchema : registerByCodeValidationSchema1}
            initialValues={{
              phoneNumber: userPhoneNumber,
              invitationCode: userInvitationCode,
              firstName: '', lastName: '', jobType: '',
              email: '', password: '', confirmPassword: ''
            }}
            onSubmit={(data: any) => {
              callAddNewPassWord(data);
            }}
          >
            {({ values, setFieldValue, dirty, isValid }) => (
              <Form>
                <Grid container columnSpacing={1} sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}>
                  {
                    !sms ?
                    <Grid item xs={7} flexGrow={1} mx={'auto'}>
                    <Box>
                      <div className='error'>
                        <ErrorMessage name="firstName" />
                      </div>
                      <FormikControl
                        control='textField'
                        name='firstName'
                        fullWidth
                        size='small'
                        value={values.firstName}
                        onChange={({ target }: any) => {
                          setFieldValue('firstName', target.value);
                        }}
                        label={'نام'}
                      />
                    </Box>
                  </Grid>
                    :
                  <></>
                  }
                  {
                    !sms ?
                  <Grid item xs={7} flexGrow={1} mx={'auto'}>
                    <Box>
                      <div className='error'>
                        <ErrorMessage name="lastName" />
                      </div>
                      <FormikControl
                        control='textField'
                        name='lastName'
                        size='small'
                        value={values.lastName}
                        onChange={({ target }: any) => {
                          setFieldValue('lastName', target.value);
                        }}
                        label={'نام خانوادگی'}
                      />
                    </Box>
                  </Grid>
                  :
                  <></>
                  }      
                  <Grid item xs={7} flexGrow={1} mx={'auto'}>
                    <Box>
                      <div className='error'>
                        <ErrorMessage name="jobType" />
                      </div>
                      <FormikControl
                        control='textField'
                        name='jobType'
                        fullWidth
                        size='small'
                        value={values.jobType}
                        onChange={({ target }: any) => {
                          setFieldValue('jobType', target.value);
                        }}
                        label={'عنوان شغلی'}
                      />
                    </Box>
                  </Grid>
                  {
                    !email ?
                  <Grid item xs={7} flexGrow={1} mx={'auto'}>
                    <Box>
                      <div className='error'>
                        <ErrorMessage name="email" />
                      </div>
                      <FormikControl
                        control='textField'
                        name='email'
                        fullWidth
                        size='small'
                        value={values.email}
                        onChange={({ target }: any) => {
                          setFieldValue('email', target.value);
                        }}
                        label={'ایمیل'}
                      />
                    </Box>
                  </Grid>
                  :
                  <></>
                  }
                  {
                    !sms ?
                  <Grid item xs={7} flexGrow={1} mx={'auto'}>
                    <Box>
                      <div className='error'>
                        <ErrorMessage name="password" />
                      </div>
                      <FormikControl
                        control='textField'
                        name='password'
                        type={showPassword1 ? 'text' : 'password'}
                        fullWidth
                        size='small'
                        value={values.password}
                        onChange={({ target }: any) => {
                          setFieldValue('password', target.value);
                        }}
                        label={'رمز عبور جدید'}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={handleClickShowPassword1}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword1 ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </Grid>
                  :
                  <></>
                  }
                  {
                    !sms  ?
                  <Grid item xs={7} flexGrow={1} mx={'auto'}>
                    <Box>
                      <div className='error'>
                        <ErrorMessage name="confirmPassword" />
                      </div>
                      <FormikControl
                        control='textField'
                        name='confirmPassword'
                        type={showPassword2 ? 'text' : 'password'}
                        fullWidth
                        size='small'
                        value={values.confirmPassword}
                        onChange={({ target }: any) => {
                          setFieldValue('confirmPassword', target.value);
                        }}
                        label={'تکرار رمز عبور جدید'}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={handleClickShowPassword2}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword2 ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                  </Grid>
                  :
                  <></>
                  }
                  <Grid item xs={6} flexGrow={1} mx={'auto'} marginTop={1}>
                    <Box>
                      <DyButton
                        caption={'تایید'}
                        color={'#00387C'}
                        onClick={() => { }}
                        disabled={addPassLoad || !isValid || !dirty}
                        variant={'contained'}
                        bgColor={'#00387C'}
                        type={'submit'}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        );

      default:
        return null;
    }
  };

  return (
    <Grid container>
      <Grid item xs={8} mx={'auto'} padding={2}>
        <Box py={3} display={'flex'} justifyContent={'space-between'} alignItems={'center'} columnGap={2}>
          <Typography variant='body1' fontWeight={600}>
            لطفا اطلاعات مورد نیاز را وارد نمایید
          </Typography>
          <LockResetIcon fontSize='large' />
          <IconButton onClick={() => setContentState({ content: 'login' })}>
            <ArrowForwardIcon />
            <Typography> برگشت </Typography>
          </IconButton>
        </Box>
      </Grid>
      <Grid item xs={10}>
        {renderContent()}
      </Grid>
      <DYToastMessage
        show={showToastMessage}
        setShow={setShowToastMessage}
        message={contentMessage}
        isSuccess={showResultToastMessage} // وضعیت موفقیت یا خطا
      />
    </Grid>
  );
};

export default RegisterByCode;